import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { TranslateService } from "@ngx-translate/core";
import { merge } from "rxjs";
import { tap } from "rxjs/operators";
import { SharedService } from "src/app/services/sharedService";
import { TasDataSource } from "src/app/services/tasGovTable.datasource";
import { TaxPayerService } from "src/app/services/taxPayer.service";
import { NotificationDetailsDialogComponent } from "../dialogs/notification-details-dialog/notification-details-dialog.component";
// import { ConfirmationDialogComponent } from "../../dialogs/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.css"],
})
export class NotificationComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  currentYear: any;
  @Input()
  category: any;
  @Input()
  @Input() type;
  currentNIU: any;
  currentYearInt: any;
  displayedYears = [];
  dataSource: TasDataSource;
  refreshDataSubscription: any;
  subscriptionConfirm: any 
  displayedColumns: string[] = ['actionDate', 'municipalityName', 'tin', 'companyName', 'type', 'actionWasMadeBy', 'action'];
  @Input() company: any;
  filterObject: any;
  loading = { inProgress : true}
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  
  constructor(
    public translate: TranslateService,
    public taxPayerService: TaxPayerService,
    public dialog: MatDialog,
    private sharedService: SharedService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
        this.displayedColumns = ['actionDate', 'municipalityName', 'tin', 'companyName', 'type', 'actionWasMadeBy', 'action'];
    }
  }

  ngOnInit() { 
    this.dataSource = new TasDataSource(this.taxPayerService);
    this.refreshDataSubscription = this.sharedService.cashPaymentPrintEmitter.subscribe(val => {
      this.taxPayerService.getTaxPayerByNiu('tax-payers', this.currentNIU).subscribe(taxPayer => {
        this.company = taxPayer
        this.dataSource = new TasDataSource(this.taxPayerService);
        this.loadTable()
      })
    })
  }

  ngAfterViewInit() {}

  stringifyWithUTC(obj) {
    return JSON.stringify(obj, (key, value) => {
      if (obj && obj[key] instanceof Date) {
        const utcDateString = new Date(obj[key].getTime() - (obj[key].getTimezoneOffset() * 60000)).toISOString();
        return utcDateString
      }
      return value;
    });
  }
  ngOnDestroy(): void {
    this.refreshDataSubscription && this.refreshDataSubscription.unsubscribe()
  }
  loadTable() {
    this.loading.inProgress = true
    this.dataSource.loadData(
      'notifications/list',
      this.stringifyWithUTC(this.filterObject),
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading
    );
  }
  openUserDialog(row) {
    this.dialog.open(NotificationDetailsDialogComponent, {
      width: '500px',
      data: row
    });
  }
  advancedSearch(filter){
    this.filterObject = { ...filter };

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
 
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
       tap(() => this.loadTable())
    )
      .subscribe();

    this.loadTable();
  }
  
  resetAdvancedSearch() {
    this.filterObject = {};
  }
  
}
